module.exports = __webpack_public_path__ + "img/9ne.e38484f2.svg";